import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../../settings/const";
import {Feature} from "../../../../core/gd/access-control/feature-access/const";

export default class SAMLSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "SAML",
            description              : "The SAML Integration module streamlines secure access management by enabling Single Sign-On (SSO) capabilities, allowing users to authenticate once and seamlessly access multiple services, thus enhancing security and user experience.",
            svgIcon                  : "isvg-saml-integration",
            settingsUrl              : "settings/integrations/saml",
            settingsMenuTopCategory  : SettingsMenuTopCategory.INTEGRATIONS,
            typeLabel                : "Integrations"
        });

        this._isEnabled             = false
        this.canDisable             = false
        // this.feature                = Feature.SSO_SAML
        // this.validateFeature()


        this.parentSection          = SettingsParentSection.INTEGRATIONS
    }

}
